export enum QuoteStatus {
  DRAFT = "DRAFT",
  SENT = "SENT",
  VIEWED = "VIEWED",
  ACCEPTED = "ACCEPTED",
  DECLINED = "DECLINED",
  EXPIRED = "EXPIRED",
  CONVERTED = "CONVERTED",
}

export const QuoteStatusLabels: Record<QuoteStatus, string> = {
  [QuoteStatus.DRAFT]: "Draft",
  [QuoteStatus.SENT]: "Sent",
  [QuoteStatus.VIEWED]: "Viewed",
  [QuoteStatus.ACCEPTED]: "Accepted",
  [QuoteStatus.DECLINED]: "Declined",
  [QuoteStatus.EXPIRED]: "Expired",
  [QuoteStatus.CONVERTED]: "Converted",
};

/** On the Quotes table a draft never shared with the patient reads as DRAFT. */
export const DraftQuoteStatusLabels: Record<QuoteStatus, string> = {
  ...QuoteStatusLabels,
  [QuoteStatus.DRAFT]: "Not Sent",
};

export const QuoteStatusBadgeVariants: Record<
  QuoteStatus,
  "default" | "neutral" | "success" | "error" | "warning" | "info"
> = {
  [QuoteStatus.DRAFT]: "neutral",
  [QuoteStatus.SENT]: "info",
  [QuoteStatus.VIEWED]: "warning",
  [QuoteStatus.ACCEPTED]: "success",
  [QuoteStatus.DECLINED]: "error",
  [QuoteStatus.EXPIRED]: "default",
  [QuoteStatus.CONVERTED]: "success",
};

export const QuoteStatusColors: Record<QuoteStatus, string> = {
  [QuoteStatus.DRAFT]: "bg-muted text-foreground-secondary",
  [QuoteStatus.SENT]: "bg-status-info-bg text-status-info-text",
  [QuoteStatus.VIEWED]: "bg-status-warning-bg text-status-warning-text",
  [QuoteStatus.ACCEPTED]: "bg-status-success-bg text-status-success-text",
  [QuoteStatus.DECLINED]: "bg-status-error-bg text-status-error-text",
  [QuoteStatus.EXPIRED]: "bg-status-orange-bg text-status-orange-text",
  [QuoteStatus.CONVERTED]: "bg-status-purple-bg text-status-purple-text",
};
